import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import * as appChatActions from '../actions/app-chat.action';
import { AppChatService } from '../../services/app-chat.service';


@Injectable()
export class AppChatEffect {
  //
  // load all messages
  //
  
  public fetchChats: Observable<Action> = createEffect(() => this._actions.pipe(
    ofType(appChatActions.AppChatInitialFetch),
    switchMap( action => {
        return this._appChatService.getAllMessages(action.payload).pipe(
          map(resp => appChatActions.AppChatInitialFetchSucceed(resp))
        )
    })
  )); 
  //
  // send messages
  //
  
  public sendChat: Observable<Action> = createEffect(() => this._actions.pipe(
    ofType(appChatActions.AppChatSendMessage),
    switchMap(action => {
        return this._appChatService.sendMessage(action).pipe(
          map(resp => appChatActions.AppChatSendMessageSucceed({payload:action.userComment}),
          catchError( error => of( appChatActions.AppChatSendMessageFail(error))))
        )
    })
  ));
 
  constructor(
    private _actions: Actions,
    private _appChatService: AppChatService) {
  }
}
